module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_arrow_cta_banner_button-3048394a1c204fc66e9e574d4a646b08.svg";